<template>
  <div class="biddingHall_w">
    <div class="div_1 card_head d_flex justify_content_sb align_item_c">
      <div class="default_title d_flex align_item_c">
        <span class="fz20 c_1A1A1A font_w_bold">{{ cmsColumn.name }}</span>
        <!-- <span class="span_1" />
        <span class="fz12 c_1A1A1A" v-if="dynamicData"
          >共有{{ dynamicData.total }}条</span
        > -->
      </div>

      <router-link  class="fz12 c_1A1A1A" to="/auction">
        更多
        <span class="fz16 c_1A1A1A font_w_bold">{{
          (dynamicData && dynamicData.total) || 0
        }}</span>
        条 >>
      </router-link>
    </div>

    <div>
      <ul class="tradeKind_w overflow_auto">
        <li
          class="tradeKind_i float_l fz14 c_1A1A1A cursor_pointer"
          :class="tradeKindIndex < 0 ? 'isActive' : ''"
          @click="onAllTradeKindClick"
          v-if="siteInfo.tradeKinds.length"
        >
          全部
        </li>
        <li
          class="tradeKind_i float_l fz14 c_1A1A1A cursor_pointer"
          v-for="(item, index) in siteInfo.tradeKinds"
          :key="item.key"
          @click="onTradeKindClick(item, index)"
          :class="tradeKindIndex === index ? 'isActive' : ''"
        >
          {{ item.value }}
        </li>
      </ul>
    </div>

    <div v-if="dynamicData" class="div_2 d_flex flex_wrap">
      <component
        :is="pro_item(item.tradeKind)"
        v-for="item in dynamicData.list"
        :key="item.id"
        :data="item"
        @click.native="onGoProjectItem(item.projectNo)"
      />
    </div>

    <div
      v-if="!dynamicData.list || !dynamicData.list.length"
      style="height: 200px"
      class="x_y_center"
    >
      <img src="@/assets/images/empty_icon.png" alt="" />
      <span style="margin: 0 0 0 10px" class="fz14">暂无数据</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {  uuid } from "@/utils";
import { auction_hall } from "@/api/portal";
import { MySocket } from "@/utils/webSocket";
import { pro_item } from "@/utils/templateClass";

import otherTradeKind_proItem from "@/components/template/otherTradeKind/AuctionItem.vue";
import smallmicro_proItem from "@/components/template/otherTradeKind/AuctionItem.vue";

export default {
  components: {
    otherTradeKind_proItem,
    smallmicro_proItem,
  },
  data() {
    return {
      activeName: "",
      parentId: null,
      cmsColumn: {}, // cms节点
      dynamicData: {}, // 竞拍大厅数据
      rows: 8, // 默认条数

      websocket: null,

      tradeKindIndex: -1,
      tradeKindCode: "",
    };
  },
  computed: {
    ...mapGetters(["siteInfo"]),
    //项目是否已结束（包含中止）
    isProjectEnd() {
      return function (stateCode) {
        return [4, 5].includes(stateCode);
      };
    },
    pro_item() {
      return function (type) {
        return pro_item(type);
      };
    },
  },
  watch: {
    tradeKindCode(n) {
      this.getBiddingHallData();
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.cmsColumn = this.siteInfo.nodes.find((i) => i.code === "auctionHall");
          this.getBiddingHallData();
        }
      },
      immediate:true,
      deep:true
    }
  },

  created() {
  },

  destroyed() {
    this.websocket?.stompClient?.disconnect(); // 关闭socket连接
    window.removeEventListener("online", this.handleWsOnline);
    window.removeEventListener("offline", this.handleWsOffline);
  },

  methods: {
    // 获取竞拍大厅数据 api
    async getBiddingHallData() {
      const { data } = await auction_hall({
        rows: this.rows,
        uid: uuid(13),
        tradeKind: this.tradeKindCode,
      }); // 如果是动态变化的数据，必须设置uid，否则浏览器会缓存！

      if (!data) {
        this.dynamicData = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0,
        };
        return;
      }

      this.dynamicData = data;
      this.initSocket(this.dynamicData.list);
    },

    // 交易品种项点击 click
    onTradeKindClick(item, index) {
      this.tradeKindIndex = index;
      this.tradeKindCode = item.key;
    },
    // 全部 click
    onAllTradeKindClick() {
      this.tradeKindIndex = -1;
      this.tradeKindCode = "";
    },
    // 初始化 socket连接
    initSocket(data) {
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API,
      });
      this.websocket.doConnect().then(() => {
        data.forEach((item, index) => {
          if (!this.isProjectEnd(item.auctionState)) {
            this.websocket.doSubscribe(
              "/topic/auction/" + item.projectNo,
              (msg) => {
                // 订阅列表的每条消息
                this.onHandleSocketResEvent(index, JSON.parse(msg.body));
              }
            );
          }
        });
      });
      window.addEventListener("online", this.handleWsOnline);
      window.addEventListener("offline", this.handleWsOffline);
    },
    // 处理网络在线
    handleWsOnline() {
      this.websocket = new MySocket({
        url: process.env.VUE_APP_WS_API,
      });
      this.websocket.doConnect().then(() => {
        this.dynamicData.list.forEach((item, index) => {
          this.websocket.doSubscribe(
            "/topic/auction/" + item.projectNo,
            (msg) => {
              //订阅列表的每条消息
              this.socketDataRes = JSON.parse(msg.body);
              this.onHandleSocketResEvent(this.socketDataRes.event);
            }
          );
        });
        this.$notify({
          type: "success",
          title: "提示",
          message: "连接成功。",
          duration: 5000,
        });
      });
    },
    // 处理网络离线
    handleWsOffline() {
      this.websocket?.stompClient?.disconnect();
      this.$notify({
        type: "warning",
        title: "提示",
        message: "网络异常，正在尝试重新连接...",
        duration: 5000,
      });
    },
    // 处理socket响应的事件
    onHandleSocketResEvent(index, resBody) {
      switch (resBody.event) {
        case "stateChange":
          this.handleStateChange(index, resBody);
          break;
        case "delayed":
          this.handleDelayed(index, resBody);
          break;
        case "bid":
          this.handleBid(index, resBody);
          break;
        case "end":
          this.handleEnd(index, resBody);
          break;
      }
    },
    // 处理-项目状态
    handleStateChange(index, resBody) {
      this.$set(
        this.dynamicData.list[index],
        "auctionState",
        Number(resBody.auctionState)
      );
      this.$set(
        this.dynamicData.list[index],
        "auctionStateDesc",
        resBody.stateDesc
      );
      this.$set(this.dynamicData.list[index], "sysDate", resBody.sysDate);
      this.$set(this.dynamicData.list[index], "state", resBody.state);
    },
    // 处理-项目延时
    handleDelayed(index, resBody) {
      this.$set(this.dynamicData.list[index], "sysDate", resBody.sysDate);
      this.$set(
        this.dynamicData.list[index],
        "auctionEndTime",
        resBody.endTime
      );
    },
    // 处理-出价
    handleBid(index, resBody) {
      this.$set(
        this.dynamicData.list[index],
        "currentPrice",
        resBody.currentPrice
      );
    },
    // 处理-项目结束
    handleEnd(index, resBody) {
      this.$set(this.dynamicData.list[index], "state", resBody.state);
      this.$set(
        this.dynamicData.list[index],
        "auctionState",
        Number(resBody.auctionState)
      );
      this.$set(
        this.dynamicData.list[index],
        "auctionStateDesc",
        resBody.stateDesc
      );
      this.$set(this.dynamicData.list[index], "stateEndTime", resBody.endTime);
      this.$set(this.dynamicData.list[index], "remark", resBody.remark);
    },

    //前往项目详情 click
    onGoProjectItem(projectNo) {
      this.$router.push({
        name: 'auctionDetail',
        query: {
          projectNo
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.biddingHall_w {
  .tradeKind_w {
    margin: 0 0 10px 0;
  }
  .tradeKind_i {
    height: 32px;
    line-height: 32px;
    padding: 0 27px;
    margin: 0 10px 10px 0;
    border: 1px solid #ccc;
    border-radius: 32px;
  }
  .isActive {
    background: #e5eef6;
    border: 1px solid #3d9dd6;
  }

  .div_1 {
    margin: 20px 0;
  }
  .div_2 {
  }
  .span_1 {
    width: 2px;
    height: 14px;
    margin: 0 4px;
    background: #0983cc;
  }
}
</style>
